module.exports = __webpack_public_path__ + "img/book4.9fbb9a2d.jpg";